import { FontSizes, ICommandBarStyles } from "@fluentui/react";

export const MOBILE_NAV_MAX_WIDTH = 1023;
export const MOBILE_NAV_MAX_WIDTH_BREAKPOINT = `@media (max-width: ${MOBILE_NAV_MAX_WIDTH}px)`;

export const CoherencePanelStyles = {
  headerButtonsContainer: {
    padding: ' 2px 0',
  },
  subComponentStyles: {},
  header: {
    fontSize: FontSizes.size24,
    padding: '0 40px',
  },
  root: {
    margin: 0,
    padding: '10px 40px',
  },
  body: {
    margin: 0,
    padding: '24px 40px',
  },
  footer: {
    borderTop: '2px solid #f5f5f5',
    margin: '0px',
    marginLeft: '0px !important',
    marginRight: '0px !important',
    padding: '24px 48px',
    selectors: {
      [MOBILE_NAV_MAX_WIDTH_BREAKPOINT]: {
        padding: '10px 20px',
      },
    },
  },
};
